import { Modal } from 'antd';
import { ReactComponent as Close } from '../../../../../resources/images/svg/close.svg';
import DefaultButton from '../../buttons/defaultButton/DefaultButton';

export default function showErrorMessageModal({
  errorText,
  okText,
  onOk = () => {},
  onClose = () => {},
}) {
  return Modal.error({
    title: null,
    icon: null,
    width: 600,
    className: 'default-modal',
    maskClosable: true,
    closable: true,
    closeIcon: <Close />,
    okButtonProps: { style: { display: 'none' } },
    footer: null,
    onCancel: onClose,
    content: (
      <div className="flex flex-col gap-10 items-center mb-[-30px]">
        <div className="flex flex-col gap-9 items-center">
          <h3 className="m-0 font-big-bold text-center">{errorText}</h3>
        </div>
        {okText && (
        <div className="flex flex-col gap-5 w-[250px] max-w-full">
          <DefaultButton
            className="w-full font-big-bold text-sm"
            onClick={() => {
              onOk();
              Modal.destroyAll();
            }}
          >
            {okText}
          </DefaultButton>
        </div>
        )}
      </div>
    ),
  });
}
